// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const RfqPage = lazy(() => import('./pages/RfqPage'));
const NegotiationsPage = lazy(() => import('./pages/NegotiationsPage'));
const ContractPricingPage = lazy(() => import('./pages/ContractPricingPage'));
const ProcurementAnalyticsPage = lazy(() => import('./pages/ProcurementAnalyticsPage'));
const SupplierOnboardingPage = lazy(() => import('./pages/SupplierOnboardingPage'));
const RequisitionsPage = lazy(() => import('./pages/RequisitionsPage'));
const MultiCurrencyTermsPage = lazy(() => import('./pages/MultiCurrencyTermsPage'));

export const ProcurementRoutes: RouteObject = {
  path: 'procurement',
  element: <ModuleGuard moduleId="operations.procurement" />,
  children: [
    { path: 'rfq', element: <RfqPage />, handle: { crumb: 'RFQ' } },
    { path: 'negotiations', element: <NegotiationsPage />, handle: { crumb: 'Negotiations' } },
    { path: 'contract-pricing', element: <ContractPricingPage />, handle: { crumb: 'Contract Pricing' } },
    { path: 'procurement-analytics', element: <ProcurementAnalyticsPage />, handle: { crumb: 'Procurement Analytics' } },
    { path: 'supplier-onboarding', element: <SupplierOnboardingPage />, handle: { crumb: 'Supplier Onboarding' } },
    { path: 'requisitions', element: <RequisitionsPage />, handle: { crumb: 'Requisitions' } },
    { path: 'multi-currency-terms', element: <MultiCurrencyTermsPage />, handle: { crumb: 'Multi Currency Terms' } },
  ],
};
